import { Download } from "lucide-react";
import { fileUrl } from "../../lib/api";

const FORMATS = [
  ["webm", "Transparent WebM", "Websites & browsers"],
  ["mov", "Transparent MOV", "Premiere, After Effects, Final Cut, DaVinci"],
  ["mp4", "MP4 on black", "Instagram, TikTok & anywhere else"],
];

export const Downloads = ({ video }) => {
  const ready = video?.status === "done";
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="downloads">
      {FORMATS.map(([k, name, desc]) => (
        <a key={k} data-testid={`download-${k}-button`}
          href={ready ? fileUrl(video.files[k]) : undefined}
          download={ready ? `ooshots-green-chrome-loop.${k}` : undefined}
          aria-disabled={!ready}
          className={`glass rounded-2xl p-5 flex items-start gap-4 group transition-colors ${ready ? "hover:border-[#00ff87]/60 cursor-pointer" : "opacity-40 pointer-events-none"}`}>
          <span className="w-10 h-10 rounded-full bg-[#00ff87]/10 text-[#00ff87] flex items-center justify-center shrink-0 group-hover:bg-[#00ff87] group-hover:text-[#041b10] transition-colors">
            <Download className="w-4 h-4" />
          </span>
          <span>
            <span className="block font-semibold text-sm">{name}</span>
            <span className="block text-xs text-gray-400 mt-1">{desc}</span>
          </span>
        </a>
      ))}
    </div>
  );
};
